import { Layout } from "antd";
import { RecomendationsSideBar } from "../../components/layout/RecomendationsSideBar";
import ResponsiveNavigation from "../../components/NewSideBar/ResponsiveNavigation";
import NewNavBar from "../newHome/NewNavBar/NewNavBar";
import NewSideBarHousing from "../../components/layout/newSideBar/NewSideBar";
import ApplicationsModal from "../../components/applications/ui/ApplicationsModal";

export const MainTemplate = ({
  routes,
  isMobile,
  uiTexts,
  showSidebarLogo = false,
}) => {
  const { Header, Content, Sider } = Layout;
  const layoutClassName = showSidebarLogo
    ? "main-template-shell main-template-shell--sidebar-logo"
    : "main-template-shell";

  return (
    <>
      {!isMobile ? (
        <Layout className={layoutClassName}>
          <Header className={"main-header"}>
            <NewNavBar />
          </Header>
          <Sider className={"navigation-menu"}>
            <NewSideBarHousing uiTexts={uiTexts} />
          </Sider>
          <Content style={{ background: "var(--gray-bg-color)" }}>
            {routes}
          </Content>
        </Layout>
      ) : (
        <Layout className={layoutClassName}>
          <Header className={"main-header"}>
            <NewNavBar />
          </Header>

          <NewSideBarHousing uiTexts={uiTexts} />

          <Layout>
            <Content style={{ background: "var(--gray-bg-color)" }}>
              {routes}
            </Content>
          </Layout>
        </Layout>
      )}
    </>
  );
};
